import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin } from 'lucide-react';
const leaders = [{
  name: 'Darrell Craig',
  title: 'Co-Founder',
  bio: 'I bring a former product manager mindset and real craft to turning growth goals into clear, executable strategy. For me, strategy is creating advantage in the real world of politics, constraints and opportunity cost.',
  image: 'https://thinkact.b-cdn.net/DC1.jpeg',
  linkedin: 'https://linkedin.com/in/darrellcraig'
}, {
  name: 'Dilpreet Kaur',
  title: 'Co-Founder',
  bio: 'Fearless. Catalyst. Vision keeper amongst the noise. Helps others realize their potential. I am the one friends make their one phone call to when wrongly imprisoned.',
  image: 'https://thinkact.b-cdn.net/DK1.jpeg',
  linkedin: 'https://www.linkedin.com/in/kaurdilpreet/'
}];
export function Leadership() {
  return <section id="about" className="relative py-32 px-6 lg:px-8 bg-[#0A1628] overflow-hidden" data-id="element-149">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-gradient-to-br from-[#0F52BA]/20 to-transparent rounded-full blur-3xl" data-id="element-150"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-gradient-to-tl from-[#06B6D4]/10 to-transparent rounded-full blur-3xl" data-id="element-151"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-152">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mb-24" data-id="element-153">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight text-white" style={{
          fontFamily: 'Space Grotesk, sans-serif'
        }} data-id="element-154">
            Meet our leadership
          </h2>
          <p className="text-xl leading-relaxed text-gray-300" data-id="element-155">
            Founded by leaders who navigated from operators to trusted advisors
            to senior leaders at companies like Microsoft, Google and
            Salesforce, earning a reputation for delivering innovative solutions
            that drive real impact.
          </p>
        </motion.div>

        {/* Leadership profiles */}
        <div className="grid md:grid-cols-2 gap-20 lg:gap-32 max-w-6xl" data-id="element-156">
          {leaders.map((leader, index) => <motion.div key={leader.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col" data-id="element-157">
              {/* Photo */}
              <div className="relative mb-8" data-id="element-158">
                <div className="w-full aspect-square max-w-sm overflow-hidden rounded-2xl" data-id="element-159">
                  <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" data-id="element-160" />
                </div>
              </div>

              {/* Info */}
              <div className="flex-1" data-id="element-161">
                <h3 className="text-3xl font-bold mb-2 leading-tight text-white" style={{
              fontFamily: 'Space Grotesk, sans-serif'
            }} data-id="element-162">
                  {leader.name}
                </h3>
                <p className="text-lg font-semibold mb-6 text-[#06B6D4]" data-id="element-163">
                  {leader.title}
                </p>
                <p className="text-base leading-relaxed mb-8 text-gray-300" data-id="element-164">
                  {leader.bio}
                </p>

                {/* LinkedIn link */}
                <a href={leader.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-[#06B6D4] hover:text-white transition-colors group" data-id="element-165">
                  <Linkedin className="w-5 h-5" data-id="element-166" />
                  <span data-id="element-167">Connect on LinkedIn</span>
                  <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-168">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-169" />
                  </svg>
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}